export default __webpack_public_path__ + "static/media/demo4.f5f26c79.png";